<app-hero [title]="'Für einen Kurs bewerben'"></app-hero>

<section class="apply section py-5" *ngIf="isloggedIn">
  <div class="container">
    <div class="row g-5 align-items-center">

      <!-- Left: Course Info -->
      <div class="col-lg-6">
        <h2 class="mb-3">{{ courseData?.title }}</h2>
        <p>{{ courseData?.description }}</p>
        <img [src]="courseData?.image" [alt]="courseData?.title" class="img-fluid rounded shadow mt-3">
      </div>

      <!-- Right: Apply Form -->
      <div class="col-lg-6">
        <div class="card shadow p-4 rounded">
          <h4 class="mb-3">Jetzt bewerben</h4>
          <form (ngSubmit)="onSubmit()" #applyForm="ngForm">

            <div class="mb-3">
              <label class="form-label">Vollständiger Name</label>
              <input type="text" class="form-control" name="name" [(ngModel)]="userInfo.fullName" required>
            </div>

            <div class="mb-3">
              <label class="form-label">E-Mail</label>
              <input type="email" class="form-control" name="email" [(ngModel)]="userInfo.email" required>
            </div>

            <div class="mb-3 col-md-6">
              <label class="form-label" for="phoneNumber">Telefonnummer</label>
              <div class="input-group input-group-merge">
                <select id="phoneCode" class="select2 form-select" name="phoneCode" [(ngModel)]="userInfo.phoneCode">
                  <option value="" disabled>Wählen Sie Ihren Ländervorwahl</option>
                  <option value="+93">Afghanistan (+93)</option>
                  <option value="+355">Albanien (+355)</option>
                  <option value="+213">Algerien (+213)</option>
                  <option value="+376">Andorra (+376)</option>
                  <option value="+244">Angola (+244)</option>
                  <option value="+1">Anguilla (+1)</option>
                  <option value="+672">Antarktika (+672)</option>
                  <option value="+1">Antigua und Barbuda (+1)</option>
                  <option value="+54">Argentinien (+54)</option>
                  <option value="+374">Armenien (+374)</option>
                  <option value="+297">Aruba (+297)</option>
                  <option value="+61">Australien (+61)</option>
                  <option value="+43">Österreich (+43)</option>
                  <option value="+994">Aserbaidschan (+994)</option>
                  <option value="+1">Bahamas (+1)</option>
                  <option value="+973">Bahrain (+973)</option>
                  <option value="+880">Bangladesch (+880)</option>
                  <option value="+1">Barbados (+1)</option>
                  <option value="+375">Belarus (+375)</option>
                  <option value="+32">Belgien (+32)</option>
                  <option value="+501">Belize (+501)</option>
                  <option value="+229">Benin (+229)</option>
                  <option value="+1">Bermuda (+1)</option>
                  <option value="+975">Bhutan (+975)</option>
                  <option value="+591">Bolivien (+591)</option>
                  <option value="+387">Bosnien und Herzegowina (+387)</option>
                  <option value="+267">Botswana (+267)</option>
                  <option value="+55">Brasilien (+55)</option>
                  <option value="+246">Britisches Territorium im Indischen Ozean (+246)</option>
                  <option value="+1">Britische Jungferninseln (+1)</option>
                  <option value="+673">Brunei (+673)</option>
                  <option value="+359">Bulgarien (+359)</option>
                  <option value="+226">Burkina Faso (+226)</option>
                  <option value="+257">Burundi (+257)</option>
                  <option value="+855">Kambodscha (+855)</option>
                  <option value="+237">Kamerun (+237)</option>
                  <option value="+1">Kanada (+1)</option>
                  <option value="+238">Kap Verde (+238)</option>
                  <option value="+1">Kaimaninseln (+1)</option>
                  <option value="+236">Zentralafrikanische Republik (+236)</option>
                  <option value="+235">Tschad (+235)</option>
                  <option value="+56">Chile (+56)</option>
                  <option value="+86">China (+86)</option>
                  <option value="+57">Kolumbien (+57)</option>
                  <option value="+269">Komoren (+269)</option>
                  <option value="+242">Kongo (+242)</option>
                  <option value="+243">Kongo, Demokratische Republik (+243)</option>
                  <option value="+682">Cookinseln (+682)</option>
                  <option value="+506">Costa Rica (+506)</option>
                  <option value="+225">Elfenbeinküste (+225)</option>
                  <option value="+385">Kroatien (+385)</option>
                  <option value="+53">Kuba (+53)</option>
                  <option value="+599">Curaçao (+599)</option>
                  <option value="+357">Zypern (+357)</option>
                  <option value="+420">Tschechische Republik (+420)</option>
                  <option value="+45">Dänemark (+45)</option>
                  <option value="+253">Dschibuti (+253)</option>
                  <option value="+1">Dominica (+1)</option>
                  <option value="+1">Dominikanische Republik (+1)</option>
                  <option value="+593">Ecuador (+593)</option>
                  <option value="+20">Ägypten (+20)</option>
                  <option value="+503">El Salvador (+503)</option>
                  <option value="+240">Äquatorialguinea (+240)</option>
                  <option value="+291">Eritrea (+291)</option>
                  <option value="+372">Estland (+372)</option>
                  <option value="+268">Eswatini (+268)</option>
                  <option value="+251">Äthiopien (+251)</option>
                  <option value="+500">Falklandinseln (+500)</option>
                  <option value="+298">Färöer-Inseln (+298)</option>
                  <option value="+679">Fidschi (+679)</option>
                  <option value="+358">Finnland (+358)</option>
                  <option value="+33">Frankreich (+33)</option>
                  <option value="+594">Französisch-Guayana (+594)</option>
                  <option value="+689">Französisch-Polynesien (+689)</option>
                  <option value="+241">Gabun (+241)</option>
                  <option value="+220">Gambia (+220)</option>
                  <option value="+995">Georgien (+995)</option>
                  <option value="+49">Deutschland (+49)</option>
                  <option value="+233">Ghana (+233)</option>
                  <option value="+350">Gibraltar (+350)</option>
                  <option value="+30">Griechenland (+30)</option>
                  <option value="+299">Grönland (+299)</option>
                  <option value="+1">Grenada (+1)</option>
                  <option value="+590">Guadeloupe (+590)</option>
                  <option value="+1">Guam (+1)</option>
                  <option value="+502">Guatemala (+502)</option>
                  <option value="+44">Guernsey (+44)</option>
                  <option value="+224">Guinea (+224)</option>
                  <option value="+245">Guinea-Bissau (+245)</option>
                  <option value="+592">Guyana (+592)</option>
                  <option value="+509">Haiti (+509)</option>
                  <option value="+504">Honduras (+504)</option>
                  <option value="+852">Hongkong (+852)</option>
                  <option value="+36">Ungarn (+36)</option>
                  <option value="+354">Island (+354)</option>
                  <option value="+91">Indien (+91)</option>
                  <option value="+62">Indonesien (+62)</option>
                  <option value="+98">Iran (+98)</option>
                  <option value="+964">Irak (+964)</option>
                  <option value="+353">Irland (+353)</option>
                  <option value="+44">Isle of Man (+44)</option>
                  <option value="+972">Israel (+972)</option>
                  <option value="+39">Italien (+39)</option>
                  <option value="+1">Jamaika (+1)</option>
                  <option value="+81">Japan (+81)</option>
                  <option value="+44">Jersey (+44)</option>
                  <option value="+962">Jordanien (+962)</option>
                  <option value="+7">Kasachstan (+7)</option>
                  <option value="+254">Kenia (+254)</option>
                  <option value="+686">Kiribati (+686)</option>
                  <option value="+383">Kosovo (+383)</option>
                  <option value="+965">Kuwait (+965)</option>
                  <option value="+996">Kirgisistan (+996)</option>
                  <option value="+856">Laos (+856)</option>
                  <option value="+371">Lettland (+371)</option>
                  <option value="+961">Libanon (+961)</option>
                  <option value="+266">Lesotho (+266)</option>
                  <option value="+231">Liberia (+231)</option>
                  <option value="+218">Libyen (+218)</option>
                  <option value="+423">Liechtenstein (+423)</option>
                  <option value="+370">Litauen (+370)</option>
                  <option value="+352">Luxemburg (+352)</option>
                  <option value="+853">Macau (+853)</option>
                  <option value="+389">Nordmazedonien (+389)</option>
                  <option value="+261">Madagaskar (+261)</option>
                  <option value="+265">Malawi (+265)</option>
                  <option value="+60">Malaysia (+60)</option>
                  <option value="+960">Malediven (+960)</option>
                  <option value="+223">Mali (+223)</option>
                  <option value="+356">Malta (+356)</option>
                  <option value="+692">Marshallinseln (+692)</option>
                  <option value="+596">Martinique (+596)</option>
                  <option value="+222">Mauretanien (+222)</option>
                  <option value="+230">Mauritius (+230)</option>
                  <option value="+262">Mayotte (+262)</option>
                  <option value="+52">Mexiko (+52)</option>
                  <option value="+691">Mikronesien (+691)</option>
                  <option value="+373">Moldawien (+373)</option>
                  <option value="+377">Monaco (+377)</option>
                  <option value="+976">Mongolei (+976)</option>
                  <option value="+382">Montenegro (+382)</option>
                  <option value="+1">Montserrat (+1)</option>
                  <option value="+212">Marokko (+212)</option>
                  <option value="+258">Mosambik (+258)</option>
                  <option value="+95">Myanmar (+95)</option>
                  <option value="+264">Namibia (+264)</option>
                  <option value="+674">Nauru (+674)</option>
                  <option value="+977">Nepal (+977)</option>
                  <option value="+31">Niederlande (+31)</option>
                  <option value="+687">Neukaledonien (+687)</option>
                  <option value="+64">Neuseeland (+64)</option>
                  <option value="+505">Nicaragua (+505)</option>
                  <option value="+227">Niger (+227)</option>
                  <option value="+234">Nigeria (+234)</option>
                  <option value="+683">Niue (+683)</option>
                  <option value="+672">Norfolkinsel (+672)</option>
                  <option value="+850">Nordkorea (+850)</option>
                  <option value="+1">Nördliche Marianen (+1)</option>
                  <option value="+47">Norwegen (+47)</option>
                  <option value="+968">Oman (+968)</option>
                  <option value="+92">Pakistan (+92)</option>
                  <option value="+680">Palau (+680)</option>
                  <option value="+970">Palästina (+970)</option>
                  <option value="+507">Panama (+507)</option>
                  <option value="+675">Papua-Neuguinea (+675)</option>
                  <option value="+595">Paraguay (+595)</option>
                  <option value="+51">Peru (+51)</option>
                  <option value="+63">Philippinen (+63)</option>
                  <option value="+48">Polen (+48)</option>
                  <option value="+351">Portugal (+351)</option>
                  <option value="+1">Puerto Rico (+1)</option>
                  <option value="+974">Katar (+974)</option>
                  <option value="+262">Réunion (+262)</option>
                  <option value="+40">Rumänien (+40)</option>
                  <option value="+7">Russland (+7)</option>
                  <option value="+250">Ruanda (+250)</option>
                  <option value="+590">Saint-Barthélemy (+590)</option>
                  <option value="+290">St. Helena (+290)</option>
                  <option value="+1">St. Kitts und Nevis (+1)</option>
                  <option value="+1">St. Lucia (+1)</option>
                  <option value="+590">Saint-Martin (+590)</option>
                  <option value="+508">Saint-Pierre und Miquelon (+508)</option>
                  <option value="+1">St. Vincent und die Grenadinen (+1)</option>
                  <option value="+685">Samoa (+685)</option>
                  <option value="+378">San Marino (+378)</option>
                  <option value="+239">São Tomé und Príncipe (+239)</option>
                  <option value="+966">Saudi-Arabien (+966)</option>
                  <option value="+221">Senegal (+221)</option>
                  <option value="+381">Serbien (+381)</option>
                  <option value="+248">Seychellen (+248)</option>
                  <option value="+232">Sierra Leone (+232)</option>
                  <option value="+65">Singapur (+65)</option>
                  <option value="+1">Sint Maarten (+1)</option>
                  <option value="+421">Slowakei (+421)</option>
                  <option value="+386">Slowenien (+386)</option>
                  <option value="+677">Salomonen (+677)</option>
                  <option value="+252">Somalia (+252)</option>
                  <option value="+27">Südafrika (+27)</option>
                  <option value="+82">Südkorea (+82)</option>
                  <option value="+211">Südsudan (+211)</option>
                  <option value="+34">Spanien (+34)</option>
                  <option value="+94">Sri Lanka (+94)</option>
                  <option value="+249">Sudan (+249)</option>
                  <option value="+597">Suriname (+597)</option>
                  <option value="+47">Svalbard und Jan Mayen (+47)</option>
                  <option value="+46">Schweden (+46)</option>
                  <option value="+41">Schweiz (+41)</option>
                  <option value="+963">Syrien (+963)</option>
                  <option value="+886">Taiwan (+886)</option>
                  <option value="+992">Tadschikistan (+992)</option>
                  <option value="+255">Tansania (+255)</option>
                  <option value="+66">Thailand (+66)</option>
                  <option value="+670">Timor-Leste (+670)</option>
                  <option value="+228">Togo (+228)</option>
                  <option value="+690">Tokelau (+690)</option>
                  <option value="+676">Tonga (+676)</option>
                  <option value="+1">Trinidad und Tobago (+1)</option>
                  <option value="+216">Tunesien (+216)</option>
                  <option value="+90">Türkei (+90)</option>
                  <option value="+993">Turkmenistan (+993)</option>
                  <option value="+1">Turks- und Caicosinseln (+1)</option>
                  <option value="+688">Tuvalu (+688)</option>
                  <option value="+256">Uganda (+256)</option>
                  <option value="+380">Ukraine (+380)</option>
                  <option value="+971">Vereinigte Arabische Emirate (+971)</option>
                  <option value="+44">Vereinigtes Königreich (+44)</option>
                  <option value="+1">Vereinigte Staaten (+1)</option>
                  <option value="+1">Amerikanische Jungferninseln (+1)</option>
                  <option value="+598">Uruguay (+598)</option>
                  <option value="+998">Usbekistan (+998)</option>
                  <option value="+678">Vanuatu (+678)</option>
                  <option value="+39">Vatikanstadt (+39)</option>
                  <option value="+58">Venezuela (+58)</option>
                  <option value="+84">Vietnam (+84)</option>
                  <option value="+681">Wallis und Futuna (+681)</option>
                  <option value="+212">Westsahara (+212)</option>
                  <option value="+967">Jemen (+967)</option>
                  <option value="+260">Sambia (+260)</option>
                  <option value="+263">Simbabwe (+263)</option>
                </select>
                <input
                  type="text"
                  id="phoneNumber"
                  name="phoneNumber"
                  class="form-control"
                  placeholder="Telefonnummer"
                  [(ngModel)]="userInfo.phoneNumber"
                  pattern="[0-9]{7,15}"
                  #phoneNumber="ngModel"
                />
                <div *ngIf="phoneNumber.invalid && (phoneNumber.dirty || phoneNumber.touched)" class="invalid-feedback">
                  Bitte geben Sie eine gültige Telefonnummer ein (7-15 Ziffern).
                </div>
              </div>
            </div>

            <!-- Course Level pre-filled -->
            <div class="mb-3">
              <label class="form-label">Kursniveau</label>
              <input type="text" class="form-control" [value]="level" readonly>
            </div>

            <div class="text-center">
              <button type="submit" class="btn btn-primary px-4">Jetzt bewerben</button>
            </div>
          </form>
        </div>
      </div>

    </div>
  </div>
</section>

<div *ngIf="!isloggedIn" class="d-flex align-items-center justify-content-center" style="height: 100px;">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Lädt...</span>
  </div>
</div>